import * as ZapparThree from '@zappar/zappar-threejs';
import { Params } from '../utils/types';

export class ImageTracker {
    private targetZptSrc: string;

    public imageTracker: ZapparThree.ImageTracker;
    public imageTrackerGroup: ZapparThree.ImageAnchorGroup;

    constructor(camera: ZapparThree.Camera, urlParams: Params) {
        this.targetZptSrc = 'https://ddg67ecygv8rc.cloudfront.net/sharpie/' + urlParams.packType + '/' + urlParams.penNum + urlParams.penType + '.zpt';
        this.imageTracker = new ZapparThree.ImageTrackerLoader().load(this.targetZptSrc);
        this.imageTrackerGroup = new ZapparThree.ImageAnchorGroup(camera, this.imageTracker);
    }
}